import React from 'react';
import { Box, Fab } from '@mui/material';
import { useSettings } from '../Settings';
import { openWhatsAppChat } from '../utils/links';

const WhatsAppIcon = ({ size = 28 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51h-.57c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.885-9.885 9.885M21.18 2.812A11.812 11.812 0 0012.053 0C5.462 0 .101 5.36.098 11.954c0 2.105.55 4.16 1.595 5.975L0 24l6.216-1.63a11.83 11.83 0 005.834 1.523h.005c6.589 0 11.951-5.361 11.955-11.955a11.832 11.832 0 00-2.83-8.126" fill="#fff"/>
  </svg>
);

export function FloatingWhatsApp() {
  const { settings } = useSettings();
  const whatsappNumber = settings.socials?.whatsapp || '';

  if (!whatsappNumber) return null;

  function handleClick() {
    openWhatsAppChat(whatsappNumber);
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: { xs: 24, md: 32 },
        right: { xs: 24, md: 32 },
        zIndex: 9999,
      }}
    >
      <Fab
        onClick={handleClick}
        aria-label="whatsapp"
        sx={{
          bgcolor: 'var(--color-whatsapp, #25D366)',
          width: 60,
          height: 60,
          boxShadow: '0px 8px 24px #25D36666',
          '&:hover': {
            bgcolor: 'var(--color-whatsapp-dark, #1EBE5A)',
            transform: 'scale(1.05)',
            boxShadow: '0px 12px 28px #25D36680',
          },
          transition: 'all 0.2s ease-in-out',
        }}
      >
        <WhatsAppIcon />
      </Fab>
    </Box>
  );
}
